import { TFormRowData } from "../../views/common/components/types";
import { TFixedNumberProcessResult } from "./types";

/**
 * DHCPでの自動入力
 * @param data: 端末情報フォーム
 * @returns TFixedNumberProcessResult
 */
const autoInputByDHCP = (data: TFormRowData): TFixedNumberProcessResult => {
  const circuitType = data.circuitType[0];
  const isNotLTE =
    circuitType.content === JSON.stringify({ "1": "有線LAN" }) ||
    circuitType.content === JSON.stringify({ "2": "無線LAN" });

  const dhcp = data.DHCP[0];
  const isNoDHCP = dhcp.content === JSON.stringify({ "2": "無し" });

  //   const ipAddress = data.IPAddress[0];

  return [
    {
      column: "IPAddress",
      content: "",
      isRequired: isNotLTE && isNoDHCP,
      isHide: !(isNotLTE && isNoDHCP),
    },
    {
      column: "subNet",
      content: "",
      isRequired: isNotLTE && isNoDHCP,
      isHide: !(isNotLTE && isNoDHCP),
    },
    {
      column: "gateway",
      content: "",
      isRequired: isNotLTE && isNoDHCP,
      isHide: !(isNotLTE && isNoDHCP),
    },
    {
      column: "DNS",
      content: "",
      isRequired: isNotLTE && isNoDHCP,
      isHide: !(isNotLTE && isNoDHCP),
    },
  ];
};

export default autoInputByDHCP;
